import { render } from "./oap-beauty-control.vue?vue&type=template&id=7506a288"
import script from "./oap-beauty-control.vue?vue&type=script&lang=js"
export * from "./oap-beauty-control.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__